module.exports = new __parcel__URL__("plasma_cannon_level_3.e5ecbd28.png").toString();